export default "__VITE_ASSET__CErJRk_X__"